module.exports = __webpack_public_path__ + "static/media/Ryker_600.a7f8ac35.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Selection/assets/Ryker_600.png
// module id = 686
// module chunks = 0